import create from 'zustand';

export type Strategy = `Conservative` | `Moderate` | `Agressive`;
export type Subscription = {
  startAt: Date;
  endsIn: Date;
};

export type Config = {
  allowedAmount?: number;
  botStrategy?: Strategy;
  subscription?: Subscription;
  botStatus?: `On` | `Off`;
};

type ConfigStore = {
  config: Partial<Config>;
  setConfig: (config: Partial<Config>) => void;
  setAllowedAmount: (asset: number, price: number) => void;
  getAllowedAmount: (price: number) => number;
  setStrategy: (strategy: Strategy) => void;
  getStrategy: () => Strategy;
  setSubscription: (subscription: Subscription) => void;
  getSubscription: () => Subscription | null;
  getConfigProgress: () => number;
  isConfigCompleted: () => boolean;
};

const useConfigStore = create<ConfigStore>((set, get) => ({
  // Main Store
  config: {},
  setConfig: (config) =>
    set(({ config: prevConfig }) => ({ config: { ...prevConfig, ...config } })),

  // AllowedAmount
  setAllowedAmount: (asset, price) =>
    set(({ config }) => ({
      config: { ...config, allowedAmount: asset * price },
    })),
  getAllowedAmount: (price) => {
    const { config } = get();
    return config.allowedAmount ? config.allowedAmount / price : 0;
  },

  // Strategy
  setStrategy: (strategy: Strategy) =>
    set(({ config }) => ({ config: { ...config, botStrategy: strategy } })),
  getStrategy: () => {
    const { config } = get();
    return config.botStrategy ? config.botStrategy : `Conservative`;
  },

  // Subscription
  setSubscription: (subscription) =>
    set(({ config }) => ({ config: { ...config, subscription } })),
  getSubscription: () => {
    const { config } = get();
    return config.subscription ? config.subscription : null;
  },

  // Progress
  getConfigProgress: () => {
    const { config } = get();
    if (config.botStatus) return 4;
    if (config.subscription) return 3;
    if (config.botStrategy) return 2;
    if (config.allowedAmount) return 1;
    return 0;
  },
  isConfigCompleted: () => get().getConfigProgress() >= 3,
}));

export default useConfigStore;
